






import Vue, { PropType } from 'vue';

import {
  Booth,
} from 'mostra';

export default Vue.extend({
  name: 'g-booth-preview-form',
  props: {
    boothId: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<Booth>,
      required: true,
    },
  },
  computed: {
    src(): string {
      return `/ssr/exh/g/bt/${this.boothId}?pv=1`;
    },
  },
});
